import { put } from "redux-saga/effects";
import {
  getAllTransaction,
  getFilterTransaction,
  getPerTransactionAll,
  getPerTransactionFilter,
  createTransaction,
  searchTransactionByTraceNo,
  getClaimLocked,
  putChangeClaimLocked,
} from "../../Services";

export function* getAllTransactionSaga(action) {
  const payload = action.payload;
  try {
    const res = yield getAllTransaction(payload);
    yield put({ type: "REQ_GET_ALL_TRANSACTION_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_ALL_TRANSACTION_FAILED", errData: e });
  }
}

export function* getFilterTransactionSaga(action) {
  const payload = action.payload;

  try {
    console.log("payload", payload);
    const res = yield getFilterTransaction(payload);

    yield put({ type: "REQ_GET_FILTER_TRANSACTION_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_FILTER_TRANSACTION_FAILED", errData: e });
  }
}

export function* getPerTransactionAllSaga(action) {
  const payload = action.payload;

  try {
    const res = yield getPerTransactionAll(payload);
    yield put({
      type: "REQ_GET_PER_TRANSACTION_ALL_SUCCEEDED",
      data: res.data,
    });
  } catch (e) {
    yield put({ type: "REQ_GET_PER_TRANSACTION_ALL_FAILED", errData: e });
  }
}

export function* getPerTransactionFilterSaga(action) {
  const payload = action.payload;

  try {
    const res = yield getPerTransactionFilter(payload);
    yield put({
      type: "REQ_GET_PER_TRANSACTION_FILTER_SUCCEEDED",
      data: res.data,
    });
  } catch (e) {
    yield put({ type: "REQ_GET_PER_TRANSACTION_FILTER_FAILED", errData: e });
  }
}

export function* createTransactionSaga(action) {
  const payload = action.payload;
  try {
    const res = yield createTransaction(payload);
    yield put({ type: "REQ_CREATE_TRANSACTION_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CREATE_TRANSACTION_FAILED", errData: e });
  }
}

export function* searchTransactionByTraceNoSaga(action) {
  const payload = action.payload;

  try {
    const res = yield searchTransactionByTraceNo(payload);
    yield put({
      type: "REQ_SEARCH_TRANSACTION_BY_TRACE_NO_SUCCEEDED",
      data: res.data,
    });
  } catch (e) {
    yield put({
      type: "REQ_SEARCH_TRANSACTION_BY_TRACE_NO_FAILED",
      errData: e,
    });
  }
}

export function* getClaimLockedSaga(action) {
  const payload = action.payload;

  try {
    const res = yield getClaimLocked(payload);
    yield put({ type: "REQ_GET_CLAIM_LOCKED_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_CLAIM_LOCKED_FAILED", errData: e });
  }
}

export function* putChangeClaimLockedSaga(action) {
  const payload = action.payload;

  try {
    let res = yield putChangeClaimLocked(payload);
    yield put({ type: "REQ_PUT_CLAIM_LOCKED_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_PUT_CLAIM_LOCKED_FAILED", errData: e });
  }
}
